import { z } from 'zod'

/**
 * Which part picker a Housecall Pro material is offered in. Mirrors
 * `IrrigationPartKind` in prisma/schema.prisma.
 *
 * One per picker the irrigation survey offers, not one per kind of equipment:
 * a master valve is picked from the same list as any other valve. Each maps to
 * a subcategory of the irrigation materials in Housecall Pro, chosen in
 * Settings (see docs/irrigation.md, "Filing the materials").
 */
export const IRRIGATION_PART_KINDS = [
  'TIMER',
  'VALVE',
  'BALL_VALVE',
  'BACKFLOW',
  'SENSOR',
  'DECODER',
  'WELL_COMPONENT',
  'VALVE_BOX',
] as const

export const irrigationPartKindSchema = z.enum(IRRIGATION_PART_KINDS)

export type IrrigationPartKind = z.infer<typeof irrigationPartKindSchema>

/** What each picker is called on screen. */
export const IRRIGATION_PART_KIND_LABELS: Record<IrrigationPartKind, string> = {
  TIMER: 'Timers',
  VALVE: 'Valves',
  BALL_VALVE: 'Ball valves',
  BACKFLOW: 'Backflows',
  SENSOR: 'Sensors',
  DECODER: 'Decoders',
  WELL_COMPONENT: 'Well components',
  VALVE_BOX: 'Valve boxes',
}
